module.exports = __webpack_public_path__ + "img/boy.691e62d6.jpg";